import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button-loader',
  standalone: true,
  imports: [],
  templateUrl: './button-loader.component.html',
  styleUrl: './button-loader.component.css'
})
export class ButtonLoaderComponent {
  @Input() borderStyle = "3px solid #fff"
}
